import React, { useState, useEffect } from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Banner from '@src/pc/components/Banner';
import Nav from '@src/pc/components/Nav';
import Home from './Home';
import { getMarketVarieties, getAllMarket } from '@src/services/api';
import Category from './Category';
import { getQuery } from '@src/utils/index';

const Layout = () => {
    const urlNavName = decodeURIComponent(getQuery('navName')) || '首页';
    const [marketVarieties, setMarketVarieties] = useState({});
    const [clickNavName, setClickNavName] = useState(urlNavName);
    const [allMarket, setAllMarket] = useState([]);
    const getAllMarketHandle = async () => {
        try {
            const result = await getAllMarket();

            setAllMarket(result);
        } catch (error) {
            console.error(error);
        }
    };

    const getMarketVarietiesHandle = async () => {
        try {
            const result = await getMarketVarieties();

            setMarketVarieties(result);
        } catch (error) {
            console.error(error);
        }
    };

    const getData = async () => {
        await getMarketVarietiesHandle();
        await getAllMarketHandle();
    };

    useEffect(() => {
        getData();

        const timer = setInterval(() => {
            getData();
        }, 1000 * 10);

        return () => {
            // 清除定时器
            clearInterval(timer);
        };
    }, []);

    return (
        <div className={styles.layout}>
            <Banner />
            {Object.keys(marketVarieties).length > 0 && (
                <Nav marketVarieties={marketVarieties} setClickNavName={setClickNavName} clickNavName={clickNavName} />
            )}
            <div className={styles.content}>
                {clickNavName === '首页'
                    ? Object.keys(marketVarieties).length > 0 &&
                      allMarket.length > 0 && <Home marketVarieties={marketVarieties} allMarket={allMarket} />
                    : marketVarieties?.[clickNavName] && (
                          <Category marketVarietiesList={marketVarieties[clickNavName]} allMarket={allMarket} />
                      )}
            </div>
        </div>
    );
};

export default errorBoundary(Layout);
